<template>
    <v-container>
        <v-row>
            <v-col>
                <span class="headline">Brukere</span>

                <v-data-table :items="users" :headers="headers" hide-default-footer disable-pagination :mobile-breakpoint="0">
                    <template v-slot:item.role="{item}">
                        {{roleToString(item.role)}}
                    </template>
                    <template v-slot:item.approved="{item}">
                        <v-switch @change="changeApproved(item)" v-model="item.approved" :disabled="$store.getters.user.role == 0 || $store.getters.user.role == 100 " color="success"></v-switch>
                    </template>
                    <template v-slot:item.actions="{item}">
                        <v-btn icon @click="showEditUser(item)" v-if="item.id == $store.getters.user.id || $store.getters.user.role == role().MAINUSER || $store.getters.user.role == role().SUPERUSER">
                            <v-icon>mdi-pencil</v-icon>
                        </v-btn>
                        <v-btn @click="setAsMainuser(item)" v-if="mainuser.id != item.id && ($store.getters.user.role == role().MAINUSER || $store.getters.user.role == role().SUPERUSER)" :style="{'visibility': (($store.getters.user.role == role().MAINUSER || $store.getters.user.role == role().SUPERUSER) && !item.isMain) ? 'visible' : 'hidden'}" icon>
                            <v-icon>mdi-star</v-icon>
                        </v-btn>
                        <v-btn icon>
                            <v-icon>mdi-delete</v-icon>
                        </v-btn>
                    </template>
                </v-data-table>
            </v-col>
        </v-row>

        <v-speed-dial v-if="can(role().MAINUSER)" fixed right bottom direction="top" transition="slide-y-reverse-transition">
            <template v-slot:activator>
                <v-btn fab color="success">
                    <v-icon color="white">mdi-plus</v-icon>
                </v-btn>
            </template>

            <!-- <div class="d-flex flex-column align-end"> -->
            <div v-if="can(role().MAINUSER)" class="d-flex" style="align-items: center; cursor: pointer;" @click="showNewUser">
                <div class="body-2">Bruker</div>
                <v-btn fab small color="green">
                    <v-icon color="white">mdi-account</v-icon>
                </v-btn>
            </div>
            <div v-if="can(role().SUPERUSER)" class="d-flex" style="align-items: center; cursor: pointer;" @click="showNewRevisor">
                <div class="body-2">Revisor</div>
                <v-btn fab small color="green">
                    <v-icon color="white">mdi-account-tie</v-icon>
                </v-btn>
            </div>
            <div v-if="can(role().SUPERUSER)" class="d-flex" style="align-items: center; cursor: pointer;" @click="showNewSuperuser">
                <div class="body-2">Superbruker</div>
                <v-btn fab small color="green">
                    <v-icon color="white">mdi-account-group</v-icon>
                </v-btn>
            </div>
            <!-- </div> -->

        </v-speed-dial>

        <v-dialog v-model="newUser.show" :width="$vuetify.breakpoint.lgAndUp ? '50%' : '95%'">
            <new-user v-if="newUser.show" @newUser="newUserCreated" :userRole="newUser.role" :registrationNumber="newUser.registrationNumber" okText="legg til"></new-user>
        </v-dialog>

        <v-dialog v-model="editUser.show" :width="$vuetify.breakpoint.lgAndUp ? '50%' : '95%'">
            <edit-user v-if="editUser.show" :user="editUser.user" @cancel="editUser.show = false" @saved="editUser.show = false"></edit-user>
        </v-dialog>
    </v-container>
</template>

<script>
import { Role } from "../utilities/enums";
import { mapState } from "vuex";

export default {
    data: () => ({
        company: null,
        newUser: {
            show: false,
            role: undefined, // Role.USER
            registrationNumber: undefined
        },
        mainuser: { id: 0 },
        users: [],
        editUser: {
            show: false
        },
        expanded: []
    }),
    computed: {
        ...mapState({
            _users: "users"
        }),
        headers: function() {
            let _headers = [
                { text: "Fornavn", value: "firstname" },
                { text: "Etternavn", value: "lastname" },
                { text: "Brukernavn", value: "email" },
                { text: "Mobil", value: "mobile" },
                { text: "Type", value: "role" },
                { text: "Godkjent", value: "approved" },
                { text: "Handlinger", value: "actions" }
            ];

            if (this.$store.getters.user.role == Role.USER || this.$store.getters.user.role == Role.REVISOR) {
                return _headers.filter(h => h.value != "approved");
            }

            return _headers;
        }
    },
    methods: {
        // clicked(row) {
        //     console.log(row);
        // },
        showEditUser(user) {
            this.editUser.user = user;
            this.editUser.show = true;
        },
        can(role) {
            return this.$store.getters.user.role >= role;
        },
        showNewUser() {
            this.newUser.role = Role.USER;
            this.newUser.registrationNumber = this.$store.getters.company.registrationNumber;
            this.newUser.show = true;
        },
        showNewRevisor() {
            this.newUser.role = Role.REVISOR;
            this.newUser.show = true;
        },
        showNewSuperuser() {
            this.newUser.role = Role.SUPERUSER;
            this.newUser.show = true;
        },
        roleToString(role) {
            switch (role) {
                case 0:
                    return "bruker";
                case 10:
                    return "hovedbruker";
                case 100:
                    return "revisor";
                case 1000:
                    return "superbruker";
            }
        },
        async changeApproved(user) {
            // console.log(user.approved);

            if (this.$store.getters.user.id != user.id) {
                if (user.approved) {
                    await this.$store.dispatch("approveUser", { companyId: this.$store.getters.company.id, userId: user.id });
                } else {
                    await this.$store.dispatch("disapproveUser", { companyId: this.$store.getters.company.id, userId: user.id });
                }
            }
        },
        async newUserCreated() {
            try {
                // debugger;
                await this.$store.dispatch("fetchUsersForCurrentCompany");
                // this.$store.commit("users", users);
                this.newUser.show = false;
            } catch (error) {
                this.$store.commit("snackbar", { show: true, text: error, color: "error" });
            }
        },
        async setAsMainuser(user) {
            // update token of current mainuser:
            await this.$store.dispatch("setMainuser", { companyId: this.$store.getters.company.id, userId: user.id });

            if (this.$store.getters.user.role === Role.MAINUSER && this.$store.getters.user.id != user.id) {
                await this.$store.dispatch("updateToken", this.$store.getters.company.id);
            }

            this.mainuser = await this.$store.dispatch("getMainuser", { companyId: this.$store.getters.company.id });
        }
    },
    watch: {
        _users: {
            handler: function() {
                this.users = this.$store.getters.users.map(u => {
                    u.isMain = u.role === 10;
                    return u;
                });
            }
        },
        expanded: function() {
            if (this.expanded && this.expanded.length > 0) {
                if (this.$store.getters.user.role === Role.USER && this.expanded[0].id !== this.$store.getters.user.id) {
                    this.expanded.pop();
                }
            }
        }
    },
    async mounted() {
        this.users = this.$store.getters.users.map(u => {
            u.isMain = u.role === 10;
            return u;
        });

        this.mainuser = await this.$store.dispatch("getMainuser", { companyId: this.$store.getters.company.id });
    }
};
</script>

<style lang="scss">
.v-data-table__expanded__content {
    -webkit-box-shadow: none !important;
    box-shadow: none !important;
    background: #e0e0e0;
}

.v-speed-dial__list {
    align-items: flex-end !important;
}
// .v-data-table__expanded__content {
//     -webkit-box-shadow: none !important;
//     box-shadow: 10px 10px 10px green !important;
// }
</style>